import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KalturaLogger } from '@kaltura-ng/kaltura-logger';
import { BrowserService } from 'app-shared/kmc-shell/providers/browser.service';
import { Title } from '@angular/platform-browser';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { ContextualHelpService } from 'app-shared/kmc-shared/contextual-help/contextual-help.service';
import { KmcMainViewBaseService, ViewMetadata } from '../kmc-main-view-base.service';
import { KMCPermissions, KMCPermissionsService } from '../../kmc-permissions';

@Injectable()
export class AdminMultiAccountMainViewService extends KmcMainViewBaseService {
  constructor(
    logger: KalturaLogger,
    browserService: BrowserService,
    router: Router,
    private _appPermissions: KMCPermissionsService,
    appLocalization: AppLocalization,
    titleService: Title,
    contextualHelpService: ContextualHelpService,
  ) {
    super(
      appLocalization,
      logger.subLogger('AdminMultiAccountMainViewService'),
      browserService,
      router,
      titleService,
      contextualHelpService,
    );
  }

  isAvailable(): boolean {
    return (
      this._appPermissions.hasPermission(KMCPermissions.ADMIN_BASE) &&
      this._appPermissions.hasPermission(KMCPermissions.FEATURE_VAR_CONSOLE_LOGIN)
    );
  }

  getRoutePath(): string {
    return 'administration/multi-account';
  }

  getViewMetadata(): ViewMetadata {
    return {
      viewKey: 'admin-multi-account',
      title: this._appLocalization.get('app.titles.administrationMultiAccountPageTitle'),
      menu: this._appLocalization.get('app.titles.administrationMultiAccountMenuTitle'),
    };
  }
}
